import { all } from 'redux-saga/effects'
import { mySaga } from 'Motassign/CrewMgmt/sagas'
import { add, undo, redo } from 'Motassign/reducer'

export default function* rootSaga() {
  yield all([mySaga(), add(), undo(), redo()])
  // code after all-effect
}
